<template>
  <div>
    <component
      :is="computedComponentName"
      v-model="shouldShowModal"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          class="d-flex align-center justify-between filter-title"
          :class="{ 'font-weight-bold': isFilterApplied }"
          v-on="on"
          v-bind="attrs"
          >
          <div class="d-flex align-center flex-grow-1">
            <v-icon left>
              category
            </v-icon>
            Category
          </div>
          <v-icon>
            expand_more
          </v-icon>
        </div>
      </template>
      <v-card>
        <v-card-text
          class="pt-4"
          :class="{ 'black--text': isThemeLight }"
        >
          <div class="mb-1 d-flex">
            <div class="d-flex align-center flex-grow-1">
              <v-icon
                :class="{ 'black--text': isThemeLight }"
                class="mr-1"
                left
              >
                volume_down
              </v-icon>

              Category
            </div>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  :color="isThemeLight ? 'black' : null"
                  v-bind="attrs"
                  v-on="on"
                >
                  info
                </v-icon>
              </template>

              <span>
                Refine search results with only influencers that fall into the selected category
              </span>
            </v-tooltip>
          </div>

          <v-autocomplete
            v-model="form"
            :items="filteredSearchItems"
            label="Category"
            dense
            outlined
            :append-icon="null"
            return-object
            hide-details
            item-text="name"
            item-value="value"
            @change="submitForm"
            class="mt-3"
          ></v-autocomplete>

          <div v-if="appliedFilters.length" class="mt-3">
            <div
              v-for="item in appliedFilters"
              :key="item.id"
            >
              <div class="d-flex justify-space-between align-center pb-1 pt-3">
                {{ item.data.inputs.name }}

                <v-btn icon color="red" @click="removeFilterItem(item)">
                  <v-icon>
                    delete
                  </v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </component>
  </div>
</template>

<script>
// used throughout the code
const filterName = "subcategory"

const originalForm = () => ({
  name: null,
  value: null
})

export default {
  name: "FilterSubcategory",

  data: () => ({
    form: originalForm(),

    shouldShowModal: false,

    searchItems: [
      {
        name: "Business",
        value: "BUSINESS",
      },
      {
        name: "Charity Cause",
        value: "CHARITY_CAUSE",
      },
      {
        name: "College University",
        value: "COLLEGE_UNIVERSITY",
      },
      {
        name: "Community Org",
        value: "COMMUNITY_ORG",
      },
      {
        name: "Company Enterprise",
        value: "COMPANY_ENTERPRISE",
      },
      {
        name: "Government Org",
        value: "GOVERNMENT_ORG",
      },
      {
        name: "GROUP",
        value: "GROUP",
      },
      {
        name: "Internet Company",
        value: "INTERNET_COMPANY",
      },
      {
        name: "Media News Company",
        value: "MEDIA_NEWS_COMPANY",
      },
      {
        name: "Nonprofit Org",
        value: "NONPROFIT_ORG",
      },
      {
        name: "Political Org",
        value: "POLITICAL_ORG",
      },
      {
        name: "Religious Org",
        value: "RELIGIOUS_ORG",
      },
      {
        name: "Restaurant Chain",
        value: "RESTAURANT_CHAIN",
      },
      {
        name: "Retail Company",
        value: "RETAIL_COMPANY",
      },
      {
        name: "Sports League",
        value: "SPORTS_LEAGUE",
      },
      {
        name: "Sports Team",
        value: "SPORTS_TEAM",
      },
      {
        name: "Record Label",
        value: "RECORD_LABEL",
      },
      {
        name: "Actor",
        value: "ACTOR",
      },
      {
        name: "Artist",
        value: "ARTIST",
      },
      {
        name: "Athlete",
        value: "ATHLETE",
      }
    ]
  }),

  computed: {
    // show the filter as a dialog for mobile dialogs
    computedComponentName() {
      return this.isDesktopDevice ? "v-menu" : "v-dialog"
    },

    // get a list of all of them
    appliedFilters() {
      return this.$store.getters["influencerDiscovery/findFiltersByType"](filterName)
    },

    // Used to bold the filter name text
    isFilterApplied() {
      return Boolean(this.appliedFilters.length)
    },

    filteredSearchItems() {
      return this.searchItems.filter((item) => {
        return !Boolean(
          this.appliedFilters.find((search) => {
            return search.data.inputs.value ===  item.value
          })
        )
      }).sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    }
  },

  validations: {
    form: {}
  },

  methods: {
    /**
     * Takes an item and generates the text based on kind and weight
     */
    computeFilterText() {
      return `Category: ${this.form.name}`
    },

    /**
     * Push the data from either of the inputs to the filters array in Vuex Store*
     */
    async submitForm() {
      await this.$v.form.$touch()

      if (this.$v.form.$anyError) return

      this.$store.dispatch("influencerDiscovery/replaceFilter", {
        type: filterName,
        data: {
          color: "amber lighten-5",
          icon: "category",
          iconColor: "amber",
          text: this.computeFilterText(),
          inputs: {
            ...this.form
          }
        }
      })

      // finally hide the modal
      this.shouldShowModal = false
      this.form = originalForm()
    },

    /**
     * Delete the entry from vuex store
     *
     * @param {Object} item
     */
    removeFilterItem(item) {
      this.$store.dispatch("influencerDiscovery/removeFilter", item.id)
    },
  },
}
</script>
